import { useState, useEffect, } from "react";
import "bootstrap/dist/css/bootstrap.css";
import ConnectMenu  from "../../utils/connect-button";
import { useWeb3Context } from "../../hooks";
import './index.css'
import { DEFAULT_NETWORK } from "utils/constants";
import { ellipseAddress } from "utils/connect-button/utilities";
import logo from "assets/media/logo/logo.png";
import ReactGA from 'react-ga';

const Airdrop = () => {

  const {
    connected,
    providerChainID,
    address,
    getAirdrop,
    disconnect
  } = useWeb3Context()
  const [claimMessage, setClaimMessage] = useState({
    payload: '',
    type: '',
  });
  const [initialized, setInitialized] = useState(false);

  function initialiseAnalytics() {
    const TRACKING_ID = process.env.REACT_APP_GA_ID ? process.env.REACT_APP_GA_ID : '' ;
    console.log('O tracking é'+TRACKING_ID);
    ReactGA.initialize(TRACKING_ID);
  }

  useEffect(() => {
    initialiseAnalytics();
    setInitialized(true);
  }, []);

  useEffect(() => {
    if (initialized) {
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  }, [initialized]);

  const clickFunction = () => {
    try {
      getAirdrop().then(()=>{
        setClaimMessage({
          type: "primary",
          payload: `Airdrop success!
        Tokens successfully
        Address: ${address}`,
        });
      }).catch(()=>{
        setClaimMessage({
          type: "danger",
          payload: `Airdrop failed Reason: Airdrop already sent to this address`,
        });
      })
      setClaimMessage({
        payload: `
                Claiming token from Airdrop contract...
                Address: ${address}
              `,
        type: "primary",      
      });
    } catch (error) {
      
    }
    
  }

  const clickDisconnect = () =>{
    disconnect()
  }

  return (
    <div>
      <div className="container-fluid ">
        <div className="row justify-content-end mt-4">          
          <div className="col-3 mr-5">
          {connected && 
            <div>
              <span className="address">
                {ellipseAddress(address)}
              </span>
              <button 
                type="submit" 
                className="btn btn-light mb-2 col-sm-5"
                onClick={clickDisconnect}
                >
                Logout
              </button>            
            </div>
          }        
          </div>
        </div>
      </div>
      <div className="container">      
        <div className="row mt-4">
          <div className="d-flex justify-content-center">
            <div className="jumbotron">
              <img className="logo" src={logo} alt="" />
              <h1 className="text-center text-white">Airdrop</h1>
            </div>
            
          </div>
          <div className="d-flex justify-content-center mb-4">

</div>
          
        </div>        
          <div className="row mt-4">
            <div className="d-flex justify-content-center">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">How to claim your 50,000 tokens?</h5>
                  <div className="card-text">
                    <ul>
                      <li>
                        Step 1: Make sure you have configured the Ethereum network
                        with Metamask
                      </li>
                      <li>
                        Step 2: Make sure you have some ETH to pay for transaction
                        fees
                      </li>
                      <li>
                        Step 3: Click on Connect Wallet
                      </li>
                      <li>
                        Step 4: Click on Get Airdrop Button and confirm the transaction to claim your Metano tokens. 
                        This will send a transaction to the Airdrop smart contract
                      </li>
                    </ul>
                    <div className="alert alert-primary m-0">
                      <i>If you are using a mobile phone or a tablet, you can enter the airdrop.metano.org page through your metamask browser, which is located in the dropdown menu on the top left.</i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center mt-4">
            
                {!connected ? 
                  <ConnectMenu styleParam="btn btn-light mb-2 col-sm-8"/> 
                : providerChainID !== DEFAULT_NETWORK ?
                  <ConnectMenu styleParam="btn mb-2 col-sm-8"/> 
                :
                  <button 
                  type="submit" 
                  className="btn btn-primary mb-2 col-sm-8"
                  onClick={clickFunction}
                  >
                    Get Airdrop
                  </button>
                }            
            </div>

            <div className="d-flex justify-content-center mt-4">
              {typeof claimMessage.payload !== "undefined" ? (
                <div
                  className={`alert alert-${claimMessage.type}`}
                  role="alert"
                >
                  <span style={{ whiteSpace: "pre" }}>
                    {claimMessage.payload}
                  </span>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>      
      </div>
    </div>    
  );
}
export default Airdrop